import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { NavItem } from '../../NavItem'
import { layoutMessages } from '../../../translations'
import {
  useAuthenticationDispatch,
  useAuthenticationState,
} from '../../../contexts/AuthenticationContext'

const StyledNavItem = styled(NavItem)`
  border-color: ${({ theme }) => theme.toggleColor};
`

const StyledAuth = styled.div`
  display: flex;
`

export const AuthOptions = () => {
  const { loading } = useAuthenticationState()
  const authenticationDispatch = useAuthenticationDispatch()
  const { formatMessage } = useIntl()

  const handleLoginButton = () => {
    authenticationDispatch({
      type: useAuthenticationDispatch.ACTION_TYPES.SHOW_AUTHENTICATION,
      showLogin: true,
    })
  }
  const handleSignupButton = () => {
    authenticationDispatch({
      type: useAuthenticationDispatch.ACTION_TYPES.SHOW_AUTHENTICATION,
      user: false,
    })
  }

  const signInText = formatMessage(layoutMessages.signInText)
  const signUpText = formatMessage(layoutMessages.signUpText)

  if (loading) return null

  return (
    <StyledAuth id='gtm_auth-buttons'>
      <NavItem id='signInButton' as='button' ariaLabel={signInText} onClick={handleLoginButton}>
        {signInText}
      </NavItem>
      <StyledNavItem
        id='signUpButton'
        forwardedAs='button'
        outline
        ariaLabel={signUpText}
        onClick={handleSignupButton}
      >
        {signUpText}
      </StyledNavItem>
    </StyledAuth>
  )
}
